import apiClient from "../lib/api-client";

export interface DrugGeneric {
  id: string;
  name: string;
  code?: string;
  description?: string;
  scheduleType?: string;
  form?: {
    id: string;
    name: string;
  };
  therapeuticCategory?: {
    id: string;
    name: string;
  };
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  _count?: {
    products: number;
    interactions: number;
  };
}

export interface CreateDrugGenericData {
  name: string;
  code?: string;
  description?: string;
  scheduleType?: string;
  formId?: string;
  therapeuticCategoryId?: string;
}

export interface DrugGenericsParams {
  page?: number;
  limit?: number;
  search?: string;
  scheduleType?: string;
  formId?: string;
  therapeuticCategoryId?: string;
  isActive?: boolean;
}

export interface DrugGenericsResponse {
  data: DrugGeneric[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const drugGenericService = {
  getAll: async (
    params?: DrugGenericsParams,
  ): Promise<DrugGenericsResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", params.page.toString());
    if (params?.limit) searchParams.set("limit", params.limit.toString());
    if (params?.search) searchParams.set("search", params.search);
    if (params?.scheduleType)
      searchParams.set("scheduleType", params.scheduleType);
    if (params?.formId) searchParams.set("formId", params.formId);
    if (params?.therapeuticCategoryId)
      searchParams.set("therapeuticCategoryId", params.therapeuticCategoryId);
    if (params?.isActive !== undefined)
      searchParams.set("isActive", params.isActive.toString());

    const response = await apiClient.get(
      `/drug-generics?${searchParams.toString()}`,
    );
    return response.data;
  },

  getById: async (id: string): Promise<DrugGeneric> => {
    const response = await apiClient.get(`/drug-generics/${id}`);
    return response.data;
  },

  search: async (query: string): Promise<DrugGeneric[]> => {
    const response = await apiClient.get(
      `/drug-generics/search?q=${encodeURIComponent(query)}`,
    );
    return response.data;
  },

  create: async (data: CreateDrugGenericData): Promise<DrugGeneric> => {
    const response = await apiClient.post("/drug-generics", data, {
      headers: { "Idempotency-Key": crypto.randomUUID() },
    });
    return response.data;
  },

  update: async (
    id: string,
    data: Partial<CreateDrugGenericData>,
  ): Promise<DrugGeneric> => {
    const response = await apiClient.patch(`/drug-generics/${id}`, data, {
      headers: { "Idempotency-Key": crypto.randomUUID() },
    });
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/drug-generics/${id}`, {
      headers: { "Idempotency-Key": crypto.randomUUID() },
    });
  },
};
